/* eslint-disable sonarjs/no-duplicate-string */
export const LEVELS = {
  ROCKSTAR: 'ROCKSTAR',
  SUPERSTAR: 'SUPERSTAR',
  MEGASTAR: 'MEGASTAR',
  NONE: 'NONE',
};

export const PAGE_VARIANTS = {
  ADDED_TO_BAG_PAGE: 'pageVariant1',
  VIEW_BAG_PAGE: 'pageVariant2',
  CONFIMRATION_PAGE: 'pageVariant3',
};

export const REWARDS_LEVEL_COLOR = {
  ROCKSTAR: '#93C5EA',
  SUPERSTAR: '#4B9FDD',
  MEGASTAR: '#254F6E',
};
